import { TypographyProps } from 'Modules/ui3';

import { EmissionStatus } from '../../api';


export enum StatusVariant {
    default = 'default',
    disabled = 'disabled',
    active = 'active',
}
export interface DfaStatusProps extends Omit<TypographyProps<'div'>, 'variant'> {
    status: EmissionStatus;
    customText?: string;
    variant?: StatusVariant;
}
